import { createNativeRequest, platform } from '@mx/core';
import { AxiosRequestConfig } from 'axios';

import { request } from '../request';
import {
  ICreateUserToneModelReq,
  ICreateUserToneModelResp,
  IGetMaterialListReq,
  IGetMaterialListResp,
  IGetVoiceRepoWithTagReq,
  IGetVoiceRepoWithTagResp,
  ICreateMaterialReq,
  ICreateMaterialResp,
  IUpdateMaterialReq,
  IDeleteMaterialReq,
  IRefinePromptReq,
  IRefinePromptResp,
  IPreviewAvatarReq,
  IPollPreviewAvatarReq,
  IPollPreviewAvatarResp,
  IGetMaterialByIdReq,
  IGetMaterialByIdResp,
  IQueryWebInpaintTimesReq,
  IQueryWebInpaintTimesResp,
  IPageQueryAvatarStyleReq,
  IPageQueryAvatarStyleResp,
  IModerationImgReq,
  IModerationImgResp,
  IQueryPictureStyleDetailReq,
  IQueryPictureStyleDetailResp,
  IGetWebPaintStyleReq,
  IGetWebPaintStyleResp,
} from '../types/material';
import { IPreviewToneReq, IPreviewToneResp } from '../types/tone';

export const postGetMaterialList = async (
  data: IGetMaterialListReq,
  config?: AxiosRequestConfig
): Promise<IGetMaterialListResp> => {
  const url = '/weaver/api/v1/material/get_material_list';
  return await request.post(url, data, config || {});
};

// 创建素材
export const postCreateMaterial = async (
  data: ICreateMaterialReq,
  config?: AxiosRequestConfig
): Promise<ICreateMaterialResp> => {
  const url = '/weaver/api/v1/material/create_material';
  return await request.post(url, data, config || {});
};

export const postUpdateMaterial = async (
  data: IUpdateMaterialReq,
  config?: AxiosRequestConfig
): Promise<void> => {
  const url = '/weaver/api/v1/material/update_material';
  return await request.post(url, data, config || {});
};

export const postDeleteMaterial = async (
  data: IDeleteMaterialReq,
  config?: AxiosRequestConfig
): Promise<void> => {
  const url = '/weaver/api/v1/material/delete_material';
  return await request.post(url, data, config || {});
};

export const postGetVoiceRepoWithTag = async (
  data: IGetVoiceRepoWithTagReq,
  config?: AxiosRequestConfig
): Promise<IGetVoiceRepoWithTagResp> => {
  const url = '/weaver/api/v1/npc_editor/get_voice_repo_with_tag';
  return await request.post(url, data, config || {});
};

export const postPreviewTone = async (
  data: IPreviewToneReq,
  config?: AxiosRequestConfig
): Promise<IPreviewToneResp> => {
  const url = '/weaver/api/v1/npc_editor/preview/tone';
  return await request.post(url, data, config || {});
};

export const postRefinePrompt = async (
  data: IRefinePromptReq,
  config?: AxiosRequestConfig
): Promise<IRefinePromptResp> => {
  const url = '/weaver/api/v1/npc_editor/refine_prompt';
  return await request.post(url, data, config || {});
};

// 生成预览图片
export const postPreviewAvatar = async (
  data: IPreviewAvatarReq,
  config?: AxiosRequestConfig
): Promise<any> => {
  const url = '/weaver/api/v1/npc_editor/preview/avatar';
  return await request.post(url, data, config || {}, true);
};

// 轮询用户预览头像
export const postPollPreviewAvatar = async (
  data: IPollPreviewAvatarReq,
  config?: AxiosRequestConfig
): Promise<IPollPreviewAvatarResp> => {
  const url = '/weaver/api/v1/npc_editor/poll_preview_avatar';
  return await request.post(url, data, config || {});
};

export const postGetMaterialById = async (
  data: IGetMaterialByIdReq,
  config?: AxiosRequestConfig
): Promise<IGetMaterialByIdResp> => {
  const url = '/weaver/api/v1/material/get_material_by_id';
  return await request.post(url, data, config || {});
};

export const postQueryWebInpaintTimes = async (
  data: IQueryWebInpaintTimesReq,
  config?: AxiosRequestConfig
): Promise<IQueryWebInpaintTimesResp> => {
  const url = '/weaver/api/v1/npc/query_web_inpaint_times';
  return await request.post(url, data, config || {});
};

export const postPageQueryAvatarStyle = async (
  data: IPageQueryAvatarStyleReq,
  config?: AxiosRequestConfig
): Promise<IPageQueryAvatarStyleResp> => {
  const url = '/weaver/api/v1/npc_editor/page_query_avatar_style';
  return await request.post(url, data, config || {});
};

export const postModerationImg = async (
  data: IModerationImgReq,
  config?: AxiosRequestConfig
): Promise<IModerationImgResp> => {
  const url = '/weaver/api/v1/npc_editor/moderation_img';

  if (platform.isNativePlatform) {
    return createNativeRequest<IModerationImgResp>({
      method: 'POST',
      url,
      data,
    });
  }

  return await request.post(url, data, config || {});
};

export const postQueryPictureStyleDetail = async (
  data: IQueryPictureStyleDetailReq,
  config?: AxiosRequestConfig
): Promise<IQueryPictureStyleDetailResp> => {
  const url = '/weaver/api/v1/npc/query_picture_style_detail';
  return await request.post(url, data, config || {});
};

export const postGetWebPaintStyle = async (
  data: IGetWebPaintStyleReq,
  config?: AxiosRequestConfig
): Promise<IGetWebPaintStyleResp> => {
  const url = '/weaver/api/v1/npc_editor/get_web_paint_style';
  return await request.post(url, data, config || {});
};

export const postCreateUserToneModel = async (
  data: ICreateUserToneModelReq,
  config?: AxiosRequestConfig
): Promise<ICreateUserToneModelResp> => {
  const url = '/weaver/api/v1/npc_editor/create/user_tone_model';
  return await request.post(url, data, config || {});
};
